import React, { useCallback, useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTheme } from "@mui/material/styles";
import CardPesan from "../CardPesan/CardPesan";
import ReplayIcon from "@mui/icons-material/Replay";
import useItem from "../../services/queries/useItem";
import toRupiah from "../../utils/toRupiah";
import { useAuthStore } from "../../stores/authStore";
import { useTransaksiStore } from "../../stores/transaksiStore";
import { IOptions, ParamsGetItem } from "../../constants/types";
import { ReactComponent as BelumAdaPesanan } from "../../assets/images/BelumAdaPesanan.svg";
import Swal from "sweetalert2";
import useListInvoice from "../../services/queries/useListInvoice";
import CardInvoice from "../CardInvoice/CardInvoice";
import ToggleButton from "@mui/material/ToggleButton";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import useUkmIsDueExpired from "../../services/queries/useUkmIsDueExpired";
import useUkm from "../../services/queries/useUkm";
import useUser from "../../services/queries/useUser";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";
import { Checkbox, FormControlLabel } from "@mui/material";
import ModalBayar from "../ModalBayar/ModalBayar";
import ModalKonfirmasiBayar from "../ModalKonfirmasiBayar/ModalKonfirmasiBayar";
import moment from "moment";

interface IListPesanProps {
    handleIsError: () => void;
}

enum SectionPesan {
    Keranjang = "SATUAN",
    Invoice = "INVOICE",
}

const ListPesan = ({ handleIsError }: IListPesanProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const [isScanBarcode, setIsScanBarcode] = useState<boolean>(false);
    const ukmIdUser = useAuthStore((s) => s.ukmIdUser);
    const addToCart = useTransaksiStore((s) => s.addToCart);
    const cart = useTransaksiStore((s) => s.cart);
    const openModalBayar = useTransaksiStore((s) => s.openModalBayar);
    const handleReset = useTransaksiStore((s) => s.handleReset);
    const totalHarga = useTransaksiStore((s) => s.totalHarga);
    const isKeterangan = useTransaksiStore((s) => s.isKeterangan);
    const handleIsKeterangan = useTransaksiStore((s) => s.handleIsKeterangan);

    const [diskon, setDiskon] = useState<number>();
    const [persentaseDiskon, setPersentaseDiskon] = useState<number | null>();
    const [pajak, setPajak] = useState<number>();
    const [persentasePajak, setPersentasePajak] = useState<number | null>();
    const [service, setService] = useState<number>();
    const [persentaseService, setPersentaseService] = useState<number | null>();
    const [tagihan, setTagihan] = useState<number>();
    const [uangDibayar, setUangDibayar] = useState<number>();
    const [kembalian, setKembalian] = useState<number>();
    const [sales, setSales] = useState<IOptions | null>(null);

    const [sku, setSku] = useState<string>("");
    const [inputSku, setInputSku] = useState<string>("");
    const [section, setSection] = useState<SectionPesan>(
        SectionPesan.Keranjang,
    );

    const initialParamsItem = {
        ukmId: undefined,
        size: 1000,
        isShow: 0,
        page: 1,
        search: "",
        kategori: "",
    };
    const [paramsItem, setParamsItem] =
        useState<ParamsGetItem>(initialParamsItem);
    const {
        data: item,
        refetch: refetchItem,
        isError: isErrorItem,
    } = useItem(paramsItem);
    const today = useMemo(() => moment().format("YYYY/MM/DD"), []);
    const initialParamsListInvoice = useMemo(
        () => ({
            ukmId: ukmIdUser && ukmIdUser[0],
            search: "",
            size: 100,
            page: 1,
            tanggalAwal: today,
            tanggalAkhir: today,
            kasir: "",
            sales: "",
            metodeId: "",
            voidInvoice: "",
        }),
        [today, ukmIdUser],
    );

    const {
        data: listInvoice,
        refetch: refetchListInvoice,
        isError: isErrorListInvoice,
    } = useListInvoice(initialParamsListInvoice);

    const initialParamsUkmIsDueExpired = React.useMemo(
        () => ({
            search: "",
            size: 50,
            page: 1,
            isDueExpired: 1,
        }),
        [],
    );
    const { data: ukmIsDueExpired } = useUkmIsDueExpired(
        initialParamsUkmIsDueExpired,
    );

    const { data: user } = useUser();

    const initialParamsUkm = useMemo(
        () => ({
            size: 500,
            page: 1,
            search: "",
        }),
        [],
    );
    const { data: ukm } = useUkm(initialParamsUkm);

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    const isFetchingItems = useTransaksiStore((s) => s.isFetchingItems);
    const cancelFetchingItems = useTransaksiStore((s) => s.cancelFetchingItems);
    const [keteranganBeli, setKeteranganBeli] = useState<string>("");

    // const [transaksiKe, setTransaksiKe] = useState("");

    const resetKeteranganBeli = useCallback(() => {
        setKeteranganBeli("");
    }, []);

    const handleChangeKeteranganBeli = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setKeteranganBeli(event.target.value);
    };

    const handlingRincianPembayaran = useCallback(
        (
            persentaseDiskon: number | null,
            diskon: number | null,
            persentasePajak: number | null,
            pajak: number | null,
            serviceCustom: number | null,
            serviceCustomPersen: number | null,
            tagihan: number,
            uangYangDibayar: number,
            kembalian: number,
            sales: IOptions | null,
        ) => {
            if (diskon && diskon > 0) {
                setDiskon(diskon);
            } else {
                setDiskon(0);
            }
            if (persentaseDiskon !== null) {
                setPersentaseDiskon(persentaseDiskon);
            }
            if (pajak && pajak > 0) {
                setPajak(pajak);
            } else {
                setPajak(0);
            }
            if (persentasePajak !== null) {
                setPersentasePajak(persentasePajak);
            }
            if (serviceCustom && serviceCustom > 0) {
                setService(serviceCustom);
            } else {
                setService(0);
            }
            if (serviceCustomPersen !== null) {
                setPersentaseService(serviceCustomPersen);
            }
            setTagihan(tagihan);
            setUangDibayar(uangYangDibayar);
            setKembalian(kembalian);
            setSales(sales);
        },
        [],
    );

    useEffect(() => {
        if (isFetchingItems) {
            refetchListInvoice();
            cancelFetchingItems();
        }
    }, [cancelFetchingItems, isFetchingItems, refetchListInvoice]);

    useEffect(() => {
        if (isErrorItem || isErrorListInvoice) {
            handleIsError();
        }
    }, [handleIsError, isErrorItem, isErrorListInvoice]);

    useEffect(() => {
        if (isScanBarcode) {
            setParamsItem((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
        }
    }, [isScanBarcode, ukmIdUser]);

    useEffect(() => {
        if (inputSku !== "") {
            setSku("");
            setInputSku("");
            const selectedProduct = item?.content.filter(
                (list) => list.sku === sku,
            )[0];
            if (
                (selectedProduct && selectedProduct?.stok > 0) ||
                selectedProduct?.stok === null
            ) {
                addToCart({
                    id: Number(selectedProduct?.id),
                    namaBarang: String(selectedProduct?.namaBarang),
                    namaKategori: String(selectedProduct?.kategori.nama),
                    sku: String(selectedProduct?.sku),
                    harga: Number(selectedProduct?.harga),
                    url: String(selectedProduct?.gambar),
                    jumlahStok: selectedProduct?.stok ?? null,
                    qty: 1,
                    detailBundling: selectedProduct.detailBundling,
                    hpp: selectedProduct.hpp,
                    faktur: [],
                    multipleHarga: selectedProduct.hargaMultiple.map((li) => ({
                        id: li.id,
                        harga: Number(li.harga),
                        keterangan: li.keterangan,
                    })),
                });
                // if (cart.length <= 0) {
                //     addToCart({
                //         id: Number(selectedProduct?.id),
                //         namaBarang: String(selectedProduct?.namaBarang),
                //         sku: String(selectedProduct?.sku),
                //         harga: Number(selectedProduct?.harga),
                //         url: String(selectedProduct?.gambar),
                //         jumlahStok: selectedProduct?.stok ?? null,
                //         qty: 1,
                //         detailBundling: selectedProduct.detailBundling,
                //     });
                // } else if (cart.length > 0) {
                //     if (
                //         (selectedProduct &&
                //             selectedProduct?.stok > cart[index]?.qty) ||
                //         selectedProduct?.stok === null
                //     ) {
                //         addToCart({
                //             id: Number(selectedProduct?.id),
                //             namaBarang: String(selectedProduct?.namaBarang),
                //             sku: String(selectedProduct?.sku),
                //             harga: Number(selectedProduct?.harga),
                //             url: String(selectedProduct?.gambar),
                //             jumlahStok: selectedProduct?.stok ?? null,
                //             qty: 1,
                //             detailBundling: selectedProduct.detailBundling,
                //         });
                //     } else {
                //         Swal.fire({
                //             title: "Stok Barang tidak mencukupi",
                //             position: "top-end",
                //             showConfirmButton: false,
                //             icon: "error",
                //             toast: true,
                //             timer: 3000,
                //             timerProgressBar: true,
                //             showCloseButton: true,
                //         });
                //     }
                // }
            } else if (selectedProduct && selectedProduct?.stok <= 0) {
                Swal.fire({
                    title: "Barang telah habis",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "error",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
            } else {
                Swal.fire({
                    title: "Barang tidak ditemukan",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "error",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
        }
    }, [addToCart, inputSku, item?.content, sku, ukmIdUser]);

    return (
        <React.Fragment>
            <Box
                display="grid"
                gridTemplateRows="auto auto 1fr auto auto"
                sx={{
                    height: isPhoneScreen
                        ? ukmData &&
                          ukmIsDueExpired &&
                          ukmIsDueExpired.totalElements > 0 &&
                          ukmIsDueExpired.content.filter(
                              (list) => list.id === ukmData.id,
                          ).length > 0
                            ? "calc(100vh - 98px)"
                            : "calc(100vh - 56px)"
                        : isLaptopScreen
                        ? ukmData &&
                          ukmIsDueExpired &&
                          ukmIsDueExpired.totalElements > 0 &&
                          ukmIsDueExpired.content.filter(
                              (list) => list.id === ukmData.id,
                          ).length > 0
                            ? "calc(100vh - 48.75px)"
                            : "100vh"
                        : "calc(100vh - 64px)",
                }}
            >
                <Box paddingTop={2} paddingX={2}>
                    <ToggleButtonGroup
                        color="primary"
                        value={section}
                        exclusive
                        size="small"
                        onChange={(_, value) => {
                            if (value !== null) {
                                setSection(value);
                            }
                        }}
                        fullWidth
                    >
                        <ToggleButton value={SectionPesan.Keranjang}>
                            Keranjang
                        </ToggleButton>
                        <ToggleButton value={SectionPesan.Invoice}>
                            Daftar Transaksi
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {section === SectionPesan.Keranjang && (
                    <React.Fragment>
                        <Box>
                            <Box
                                display="grid"
                                gridTemplateColumns="1fr auto"
                                marginX={2}
                                marginY={1}
                                gap={2}
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Typography
                                    variant={isTabletScreen ? "body2" : "h6"}
                                    fontSize={
                                        isPhoneScreen ? "18px" : undefined
                                    }
                                    fontWeight="bold"
                                >
                                    Barang yang Dipesan
                                </Typography>
                                {/* <Button
                        variant="contained"
                        onClick={() => setIsScanBarcode(!isScanBarcode)}
                        startIcon={<IoBarcodeOutline size={32} />}
                        size="medium"
                    >
                        Mode Barcode
                    </Button> */}
                                <Stack
                                    direction="column"
                                    spacing={0}
                                    alignItems="center"
                                >
                                    <Typography
                                        variant="body2"
                                        fontSize="0.75rem"
                                        fontWeight="bold"
                                    >
                                        Mode Barcode
                                    </Typography>
                                    <ClickAwayListener
                                        onClickAway={() =>
                                            setIsScanBarcode(false)
                                        }
                                    >
                                        <Stack
                                            direction="row"
                                            spacing={0}
                                            alignItems="center"
                                        >
                                            <Typography
                                                variant="body2"
                                                fontSize="0.75rem"
                                            >
                                                Off
                                            </Typography>
                                            <Switch
                                                checked={isScanBarcode}
                                                size="small"
                                                onChange={() =>
                                                    setIsScanBarcode(
                                                        (prev) => !prev,
                                                    )
                                                }
                                                inputProps={{
                                                    "aria-label": "controlled",
                                                }}
                                            />
                                            <Typography
                                                variant="body2"
                                                fontSize="0.75rem"
                                            >
                                                On
                                            </Typography>
                                        </Stack>
                                    </ClickAwayListener>
                                </Stack>
                                {/* <Link
                        onClick={() => setIsScanBarcode(!isScanBarcode)}
                        sx={{ display: "flex", cursor: "pointer" }}
                    >
                        <IoBarcodeOutline size={32} />
                    </Link> */}
                            </Box>
                            {isScanBarcode && (
                                <Stack
                                    marginLeft={2}
                                    marginBottom={3}
                                    spacing={2}
                                    direction="row"
                                    alignItems="center"
                                >
                                    <Typography
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "caption"
                                                : "subtitle2"
                                        }
                                    >
                                        Input SKU (Scan)
                                    </Typography>
                                    <TextField
                                        value={sku}
                                        size="small"
                                        autoFocus={isScanBarcode === true}
                                        onChange={(e) => setSku(e.target.value)}
                                        onKeyPress={(e) => {
                                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                            e.key === "Enter"
                                                ? setInputSku(sku)
                                                : undefined;
                                        }}
                                        sx={{
                                            width: isPhoneScreen
                                                ? undefined
                                                : 200,
                                        }}
                                        inputProps={{
                                            style: {
                                                height: 20,
                                            },
                                        }}
                                    />
                                </Stack>
                            )}
                        </Box>
                        <Box
                            className="hide-scroll"
                            marginX={2}
                            sx={{
                                overflowY: "auto",
                            }}
                        >
                            {cart.length > 0 ? (
                                cart.map((rows) => (
                                    <CardPesan
                                        key={rows.id}
                                        pesan={rows}
                                    />
                                ))
                            ) : (
                                <Box
                                    display="flex"
                                    flex={1}
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <BelumAdaPesanan
                                        width={isTabletScreen ? "20%" : "50%"}
                                        style={{ height: "fit-content" }}
                                    />
                                    <Typography
                                        marginTop={
                                            isTabletScreen
                                                ? 2
                                                : isPhoneScreen
                                                ? 1
                                                : 5
                                        }
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "body2"
                                                : "h6"
                                        }
                                        fontWeight="bold"
                                    >
                                        Belum ada pesanan
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Divider />
                        <Box paddingX={2} paddingY={isTabletScreen ? 1 : 2}>
                            <Box display="flex" justifyContent="space-between">
                                <Typography
                                    variant={
                                        isTabletScreen ? "body2" : "subtitle1"
                                    }
                                    color="#76747C"
                                    fontWeight={600}
                                >
                                    Subtotal Harga
                                </Typography>
                                <Typography
                                    variant={isTabletScreen ? "body2" : "h6"}
                                    fontWeight="bold"
                                >
                                    {toRupiah(totalHarga)}
                                </Typography>
                            </Box>
                        </Box>

                        <Box
                            width="100%"
                            paddingX={2}
                            paddingBottom={isTabletScreen ? 1 : 2}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isKeterangan}
                                        size={
                                            isTabletScreen ? "small" : undefined
                                        }
                                        onChange={(_, checked) => {
                                            handleIsKeterangan(checked);
                                        }}
                                    />
                                }
                                label="Tambah Keterangan"
                                componentsProps={{
                                    typography: {
                                        fontSize: isTabletScreen
                                            ? "12px"
                                            : undefined,
                                    },
                                }}
                                sx={{
                                    height: "fit-content",
                                }}
                            />
                            {isKeterangan && (
                                <TextField
                                    label="Keterangan"
                                    multiline
                                    rows={2}
                                    fullWidth
                                    size={isTabletScreen ? "small" : undefined}
                                    value={keteranganBeli}
                                    onChange={handleChangeKeteranganBeli}
                                    helperText={`${keteranganBeli?.length}/50`}
                                    inputProps={{ maxLength: 50 }}
                                />
                            )}
                        </Box>
                        <Box marginX={2} marginBottom={isTabletScreen ? 1 : 2}>
                            <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                            >
                                <Button
                                    variant="outlined"
                                    onClick={() => handleReset()}
                                    data-testid="button-kosong"
                                    startIcon={<ReplayIcon />}
                                    size={isTabletScreen ? "small" : "large"}
                                    fullWidth
                                >
                                    Kosongkan
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => openModalBayar()}
                                    data-testid="button-bayar"
                                    size={isTabletScreen ? "small" : "large"}
                                    fullWidth
                                    disabled={cart.length === 0}
                                >
                                    Bayar
                                </Button>
                            </Stack>
                        </Box>
                    </React.Fragment>
                )}

                {section === SectionPesan.Invoice && (
                    <React.Fragment>
                        <Typography
                            variant={isTabletScreen ? "body2" : "h6"}
                            fontSize={isPhoneScreen ? "18px" : undefined}
                            fontWeight="bold"
                            marginX={2}
                            marginY={3}
                        >
                            Daftar Transaksi
                        </Typography>
                        <Box
                            className="hide-scroll"
                            marginX={2}
                            sx={{
                                overflowY: "scroll",
                            }}
                        >
                            {listInvoice && listInvoice.totalElements > 0 ? (
                                listInvoice.content.map((li) => (
                                    <CardInvoice
                                        key={li.id}
                                        invoice={li}
                                    />
                                ))
                            ) : (
                                <Box
                                    display="flex"
                                    flex={1}
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <BelumAdaPesanan
                                        width={isTabletScreen ? "20%" : "50%"}
                                        style={{ height: "fit-content" }}
                                    />
                                    <Typography
                                        marginTop={
                                            isTabletScreen
                                                ? 2
                                                : isPhoneScreen
                                                ? 1
                                                : 5
                                        }
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "body2"
                                                : "h6"
                                        }
                                        fontWeight="bold"
                                    >
                                        Belum ada transaksi
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Divider />
                        <Box paddingX={2} paddingY={isTabletScreen ? 1 : 2}>
                            <Box display="flex" justifyContent="space-between">
                                <Typography
                                    variant={
                                        isTabletScreen ? "body2" : "subtitle1"
                                    }
                                    color="#76747C"
                                    fontWeight={600}
                                >
                                    Subtotal Harga
                                </Typography>
                                <Typography
                                    variant={isTabletScreen ? "body2" : "h6"}
                                    fontWeight="bold"
                                >
                                    {toRupiah(totalHarga)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            width="100%"
                            paddingX={2}
                            paddingBottom={isTabletScreen ? 1 : 2}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        data-testid="add-notes"
                                        checked={isKeterangan}
                                        size={
                                            isTabletScreen ? "small" : undefined
                                        }
                                        onChange={(_, checked) => {
                                            handleIsKeterangan(checked);
                                        }}
                                    />
                                }
                                label="Tambah Keterangan"
                                componentsProps={{
                                    typography: {
                                        fontSize: isTabletScreen
                                            ? "12px"
                                            : undefined,
                                    },
                                }}
                                sx={{
                                    height: "fit-content",
                                }}
                            />
                            {isKeterangan && (
                                <TextField
                                    data-testid="input-username" 
                                    label="Keterangan"
                                    multiline
                                    rows={2}
                                    fullWidth
                                    size={isTabletScreen ? "small" : undefined}
                                    value={keteranganBeli}
                                    onChange={handleChangeKeteranganBeli}
                                    helperText={`${keteranganBeli?.length}/50`}
                                    inputProps={{ 
                                        "data-testid": "input-notes",
                                        maxLength: 50 
                                    }}
                                />
                            )}
                        </Box>
                        <Box marginX={2} marginBottom={isTabletScreen ? 1 : 2}>
                            <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                            >
                                <Button
                                    variant="outlined"
                                    onClick={() => handleReset()}
                                    startIcon={<ReplayIcon />}
                                    size={isTabletScreen ? "small" : "large"}
                                    fullWidth
                                >
                                    Kosongkan
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => openModalBayar()}
                                    size={isTabletScreen ? "small" : "large"}
                                    fullWidth
                                    disabled={cart.length === 0}
                                >
                                    Bayar
                                </Button>
                            </Stack>
                        </Box>
                    </React.Fragment>
                )}
            </Box>
            <ModalBayar handlingRincianPembayaran={handlingRincianPembayaran} />
            <ModalKonfirmasiBayar
                kasir={String(user?.namaLengkap)}
                sales={sales}
                diskon={diskon}
                persentaseDiskon={persentaseDiskon}
                pajak={pajak}
                persentasePajak={persentasePajak}
                serviceCustom={service}
                serviceCustomPersen={persentaseService}
                totalTagihan={Number(tagihan)}
                uangDibayar={Number(uangDibayar)}
                kembalian={Number(kembalian)}
                refetch={refetchItem}
                keteranganBeli={keteranganBeli}
                resetKeteranganBeli={resetKeteranganBeli}
            />
        </React.Fragment>
    );
};

export default ListPesan;
